import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=5cfafac6&"
import script from "./SettingsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/SettingsModal.vue
// module id = 1665
// module chunks = 1